import * as MapGL from 'react-map-gl/mapbox';
import store from './store';

interface StudyPopupProps {
  popupLocation: [number, number];
  selectedFeatures: GeoJSON.Feature<GeoJSON.Point>[];
  setSelectedFeatures: (features: GeoJSON.Feature<GeoJSON.Point>[]) => void;
  setPopupLocation: (location: [number, number] | null) => void;
}

const StudyPopup = ({ popupLocation, selectedFeatures, setSelectedFeatures, setPopupLocation }: StudyPopupProps) => {
  const popupRowClick = (objectId: string) => {
    store.setSelectedObjectId(objectId);
  };

  const getDisplayName = (feature: GeoJSON.Feature<GeoJSON.Point>) => {
    const { company_name, report_source, id } = feature.properties || {};
    const primaryName = company_name || id || 'Unknown';
    return report_source ? `${primaryName} [${report_source}]` : primaryName;
  };

  return (
    <MapGL.Popup
      key={popupLocation.toString()}
      latitude={popupLocation[1]}
      longitude={popupLocation[0]}
      maxWidth="auto"
      onClose={() => {
        setSelectedFeatures([]);
        setPopupLocation(null);
      }}
    >
      <div className="w-[450px] p-3">
        <div className="mb-2 text-xs font-semibold text-gray-700">Environmental Study Data</div>
        <div className="max-h-52 overflow-y-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="py-2 text-left text-xs font-medium text-gray-600">Location</th>
              </tr>
            </thead>
            <tbody>
              {selectedFeatures.map((feature, index) => (
                <tr
                  // biome-ignore lint/suspicious/noArrayIndexKey: legacy
                  key={index}
                  className="cursor-pointer border-b border-gray-100 transition-colors hover:bg-gray-50"
                  onClick={() => popupRowClick(feature.properties?.id?.toString())}
                >
                  <td className="py-2 text-xs text-gray-800">{getDisplayName(feature)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </MapGL.Popup>
  );
};

export default StudyPopup;
